"use client";

import { usePathname, useRouter } from "next/navigation";

export default function PreviewBanner() {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <div className="bg-neutral-700 p-3 text-center text-white">
      <p>
        Preview Mode Enabled{" "}
        <a
          href={`/api/exit-preview?path=${encodeURIComponent(pathname!)}`}
          className="underline hover:text-amber-200"
        >
          Exit Preview
        </a>
      </p>
    </div>
  );
}
